import { colors } from '@indeed/ifl-tokens';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
    footerButtons: {
        flexDirection: 'column',
        alignItems: 'stretch',
        borderTopColor: colors.neutral[300],
        borderTopWidth: 1,
        gap: 16,
        padding: 16,
        backgroundColor: 'white',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
    },
    modalContent: {
        flex: 1,
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 16,
    },
    modalContainer: {
        backgroundColor: 'white',
        flex: 1,
    },
    scrollContent: {
        flexGrow: 1,
    },
});
